import Styles from './LogoLoader.module.scss'

import { ReactComponent as Logo } from './logo.svg'

const LogoLoader = () => <Logo className={Styles.logo} />

export { LogoLoader }
